import { render, staticRenderFns } from "./ValidateButton.vue?vue&type=template&id=3ee3ae96&scoped=true&"
import script from "./ValidateButton.vue?vue&type=script&lang=js&"
export * from "./ValidateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee3ae96",
  null
  
)

export default component.exports